import { Amplify } from "aws-amplify";
import { DataStore, AuthModeStrategyType } from "aws-amplify/datastore";
import amplifyConfigDev from "./aws-exports_dev.js";
import amplifyConfigEnrx from "./aws-exports_enrx.js";

// const amplifyConfig = import.meta.env.VITE_USER_BRANCH === "dev" ? amplifyConfigDev : amplifyConfigEnrx;
const amplifyConfig = amplifyConfigEnrx;

Amplify.configure(amplifyConfig);

DataStore.configure({
  authModeStrategyType: AuthModeStrategyType.MULTI_AUTH,
});
